import { render, staticRenderFns } from "./ExerciseEvent.vue?vue&type=template&id=bc34ba4a&scoped=true"
import script from "./ExerciseEvent.vue?vue&type=script&lang=js"
export * from "./ExerciseEvent.vue?vue&type=script&lang=js"
import style0 from "./ExerciseEvent.vue?vue&type=style&index=0&id=bc34ba4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc34ba4a",
  null
  
)

export default component.exports